<template>
  <div class="lease-file-upload">
    <el-upload
      :disabled="disabled"
      :action="uploadUrl"
      :file-list="fileList"
      :limit="limit"
      :with-credentials="true"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :accept="accept"
    >
      <el-button size="small" type="primary" :disabled="disabled">{{ buttonText }}</el-button>
      <div slot="tip" class="el-upload__tip" v-if="tip">{{ tip }}</div>
    </el-upload>
  </div>
</template>

<script>
import baseUrl from "@/service/base-url";
import { resolveLeaseResourceUrl } from "@/service/fishPondLease.js";

export default {
  name: "LeaseFileUpload",
  props: {
    value: { type: String, default: "" },
    limit: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    tip: { type: String, default: "" },
    buttonText: { type: String, default: "上传文件" },
    accept: { type: String, default: ".pdf,.doc,.docx,image/*" },
    maxSizeMb: { type: Number, default: 10 }
  },
  data() {
    return {
      uploadUrl: baseUrl.imgUpload,
      fileList: [],
      syncing: false
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.syncing) return;
        this.syncFromValue(val);
      }
    }
  },
  methods: {
    syncFromValue(val) {
      if (!val) {
        this.fileList = [];
        return;
      }
      var raws = String(val)
        .split(",")
        .map(function(s) {
          return s.trim();
        })
        .filter(Boolean);
      if (this.limit > 0) {
        raws = raws.slice(0, this.limit);
      }
      this.fileList = raws.map(function(raw, index) {
        return {
          uid: "lease-file-" + index + "-" + raw,
          name: raw.split("/").pop() || "附件" + (index + 1),
          url: resolveLeaseResourceUrl(raw),
          rawUrl: raw,
          status: "success"
        };
      });
    },
    beforeUpload(file) {
      const ok = file.size / 1024 / 1024 < this.maxSizeMb;
      if (!ok) {
        this.$message.error(`文件大小不能超过 ${this.maxSizeMb}MB`);
        return false;
      }
      return true;
    },
    pickRawName(res, file) {
      if (res && (res.name || res.url || res.key)) {
        return res.name || res.url || res.key;
      }
      if (file && file.response) {
        const r = file.response;
        return r.name || r.url || r.key || "";
      }
      return "";
    },
    handleSuccess(res, file, fileList) {
      const name = this.pickRawName(res, file);
      if (!name) {
        this.$message.error("上传失败");
        return;
      }
      file.rawUrl = /^https?:\/\//i.test(name) ? name : res.url || name;
      file.url = resolveLeaseResourceUrl(file.rawUrl);
      this.fileList = (fileList || []).map(f => ({
        uid: f.uid,
        name: f.name || (f.rawUrl || "").split("/").pop() || "附件",
        status: "success",
        url: resolveLeaseResourceUrl(
          f.rawUrl || this.pickRawName(f.response, f) || ""
        ),
        rawUrl: f.rawUrl || this.pickRawName(f.response, f) || ""
      }));
      this.emitValue(this.fileList);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList || [];
      this.emitValue(this.fileList);
    },
    handleExceed() {
      this.$message.warning(`最多上传 ${this.limit} 个文件`);
    },
    emitValue(fileList) {
      var urls = (fileList || [])
        .map(f => {
          const res = f.response || {};
          return f.rawUrl || res.name || res.url || "";
        })
        .filter(Boolean);
      if (this.limit > 0) {
        urls = urls.slice(0, this.limit);
      }
      this.syncing = true;
      this.$emit("input", urls.join(","));
      var self = this;
      this.$nextTick(function() {
        self.syncing = false;
      });
    }
  }
};
</script>
